import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/service/auth.service';
import { GeneralService } from 'src/app/service/general.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss'],
  providers: [MessageService],
})
export class SigninComponent {
  receivedEmail: string = '';
  receivedPassword: string = '';
  errorMessage: string = '';
  signinSuccess: boolean = false;
  isLoading: boolean = false;
  error: string = '';

  constructor(
    private authService: AuthService,
    private router: Router,
    private generalService: GeneralService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {}

  forgotPassword() {
    this.router.navigate(['reset-password']);
  }

  register() {
    this.router.navigate(['register']);
  }

  email(data: string) {
    this.receivedEmail = data;
  }
  password(data: string) {
    this.receivedPassword = data;
  }
  handleEnterPressed() {
    this.signin();
  }
  validateEmail = (email: string) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  signin = () => {
    this.isLoading = true;
    const newUser = {
      emailAddress: this.receivedEmail,
      password: this.receivedPassword,
    };
    // console.log(this.receivedEmail)
    this.errorMessage = '';
    if (!this.validateEmail(this.receivedEmail)) {
      this.errorMessage = 'Please use a valid email';
    }
    if (
      [
        this.receivedEmail,
        this.receivedPassword,
        this.receivedPassword,
      ].includes('')
    ) {
      this.errorMessage = 'All fields are required.';
      this.isLoading = false;
    }
    this.authService.signin(newUser).subscribe(
      (res: any) => {
        // if(!this.authService.validateEmailAddress(this.receivedEmail)){
        //   this.errorMessage = "Invalid Email Address"
        //   this.processLoading = false;
        //   return;
        // }
        this.error = res.message;
        if (res.statusCode === 206) {
          this.messageService.add({
            severity: 'success',
            summary: 'Successful Signin',
            detail: 'User Successfully Signed In',
          });
          this.generalService.setToken(res.data.accessToken);
          console.log('user successfully signed In');
          this.router.navigate(['home']);
          // setTimeout(() => {
          //   this.isLoading = false;
          //   this.errorMessage = 'Problem Signin User In'
          // }, 2000);
        } else {
          this.isLoading = false;
          // this.errorMessage = ;
        }
      },
      (error) => {
        console.log(error);
        this.isLoading = false;
        // this.messageService.add({ severity: 'error', summary: 'Error', detail: error.error.message });
        this.errorMessage = error.error.message;
      }
    );
  };
}
